import { Box, Grid } from '@mui/material';
import * as React from 'react';
import { Control, FieldValues } from 'react-hook-form';

import { EditCustomDataFields } from '~/legacy-components/CustomDataFields';
import { useCustomData } from '~/scenes/PeopleModule/components/Tabs/CustomDataTab/useCustomData';

import { OverlappingEmploymentFormValues } from '../../hooks/useOverlappingEmploymentForm';
import { useSxStyles } from '../../useStyles';

interface Props {
  empId: number;
  formValues: OverlappingEmploymentFormValues;
}

export const CustomDataTabForm = React.memo(({ empId, formValues }: Props) => {
  const sxStyles = useSxStyles();

  const { editFieldData } = useCustomData({
    employeeId: empId,
  });

  const {
    formProps: { control },
  } = formValues;

  return (
    <Box sx={sxStyles.container}>
      {editFieldData.map((f, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <EditCustomDataFields
            control={control as unknown as Control<FieldValues>}
            key={`${index}/${f.name}`}
            {...{
              ...f,
              inputProps: {
                ...f.inputProps,
                name: `overlappingEmployment.customData.${f.inputProps.name}`,
              },
            }}
            label={f.name}
          />
        </Grid>
      ))}
    </Box>
  );
});
